import { Injectable } from '@angular/core';
import { CommonModalTemplatesEnum } from './common-modal-templates.enum';
import { BehaviorSubject } from 'rxjs';
import { CommonModalModel } from './common-modal.model';
import { ICommonModalModule } from './common-modal.interface';

export const temlatesHtml = {
  [CommonModalTemplatesEnum.MAX_ORDER_VALUE]: {
    id: 'order-above-limit',
    html: require(`./../../../views/modals/${CommonModalTemplatesEnum.MAX_ORDER_VALUE}.tmpl.html`)
  },
  [CommonModalTemplatesEnum.NUMBER_VERIFICATION]: {
    id: 'number-verification',
    html: require(`./../../../views/modals/${CommonModalTemplatesEnum.NUMBER_VERIFICATION}.tmpl.html`)
  },
  [CommonModalTemplatesEnum.NUMBER_VERIFICATION_SMS]: {
    id: 'number-verification-sms',
    html: require(`./../../../views/modals/${CommonModalTemplatesEnum.NUMBER_VERIFICATION_SMS}.tmpl.html`)
  },
  [CommonModalTemplatesEnum.NUMBER_VERIFICATION_SMS_SENT_AGAIN]: {
    id: 'number-verification-sms-sent-again',
    html: require(`./../../../views/modals/${CommonModalTemplatesEnum.NUMBER_VERIFICATION_SMS_SENT_AGAIN}.tmpl.html`)
  },
  [CommonModalTemplatesEnum.NUMBER_VERIFICATION_FAILURE]: {
    id: 'verification-number-failure',
    html: require(`./../../../views/modals/${CommonModalTemplatesEnum.NUMBER_VERIFICATION_FAILURE}.tmpl.html`)
  },
  [CommonModalTemplatesEnum.CONTACT_REQUEST_MODAL]: {
    id: 'number-already-play-call-v2',
    html: require(`./../../../views/modals/${CommonModalTemplatesEnum.CONTACT_REQUEST_MODAL}.tmpl.html`)
  },
  [CommonModalTemplatesEnum.CCDS_CONTACT_SUCCESS]: {
    id: 'number-already-play-call',
    html: require(`./../../../views/modals/${CommonModalTemplatesEnum.CCDS_CONTACT_SUCCESS}.tmpl.html`)
  },
  [CommonModalTemplatesEnum.CCDS_CONTACT_FAILURE]: {
    id: 'contact-phone-number-error',
    html: require(`./../../../views/modals/${CommonModalTemplatesEnum.CCDS_CONTACT_FAILURE}.tmpl.html`)
  },
  [CommonModalTemplatesEnum.INCORRECT_PASSWORD]: {
    id: 'number-verification-sms-error',
    html: require(`./../../../views/modals/${CommonModalTemplatesEnum.INCORRECT_PASSWORD}.tmpl.html`)
  },
  [CommonModalTemplatesEnum.LOTTERY_NUMBER_FAILURE]: {
    id: 'lottery-number-failure',
    html: require(`./../../../views/modals/${CommonModalTemplatesEnum.LOTTERY_NUMBER_FAILURE}.tmpl.html`)
  },
  [CommonModalTemplatesEnum.DRAWING_NEW_NUMBERS]: {
    id: 'multisim-select-number-modal',
    html: require(`./../../../views/modals/${CommonModalTemplatesEnum.DRAWING_NEW_NUMBERS}.tmpl.html`)
  },
  [CommonModalTemplatesEnum.REMOVE_SET_CONFIRMATION_MODAL]: {
    id: 'remove-set-confirmation',
    html: require(`./../../../views/modals/${CommonModalTemplatesEnum.REMOVE_SET_CONFIRMATION_MODAL}.tmpl.html`)
  },
  [CommonModalTemplatesEnum.SLOT_DETAILS_MODAL]: {
    id: 'set-summary',
    html: require(`./../../../views/modals/${CommonModalTemplatesEnum.SLOT_DETAILS_MODAL}.tmpl.html`)
  },
  [CommonModalTemplatesEnum.CONFIRMATION_CART_EMAIL]: {
    id: 'basket-send',
    html: require(`./../../../views/modals/${CommonModalTemplatesEnum.CONFIRMATION_CART_EMAIL}.tmpl.html`)
  },
  [CommonModalTemplatesEnum.CONTRACT_DETAILS_MODAL]: {
    id: 'offer-details-v2-voice',
    html: require(`./../../../views/modals/${CommonModalTemplatesEnum.CONTRACT_DETAILS_MODAL}.tmpl.html`)
  },
  [CommonModalTemplatesEnum.INTERNET_DETAILS_MODAL]: {
    id: 'offer-details-v2-data',
    html: require(`./../../../views/modals/${CommonModalTemplatesEnum.INTERNET_DETAILS_MODAL}.tmpl.html`)
  },
  [CommonModalTemplatesEnum.MODAL_CHECK_AGREEMENTS_COMPLETE]: {
    id: 'check-marketing-consents',
    html: require(`./../../../views/modals/${CommonModalTemplatesEnum.MODAL_CHECK_AGREEMENTS_COMPLETE}.tmpl.html`)
  },
  [CommonModalTemplatesEnum.LOGOUT_MODAL]: {
    id: 'logout-modal',
    html: require(`./../../../views/modals/${CommonModalTemplatesEnum.LOGOUT_MODAL}.tmpl.html`)
  },
  [CommonModalTemplatesEnum.CART_CLEAR_CONFIRMATION_MODAL]: {
    id: 'cart-clear-confirmation',
    html: require(`./../../../views/modals/${CommonModalTemplatesEnum.CART_CLEAR_CONFIRMATION_MODAL}.tmpl.html`)
  },
  [CommonModalTemplatesEnum.ADDONS_MODAL]: {
    id: 'additional-services',
    html: require(`./../../../views/modals/${CommonModalTemplatesEnum.ADDONS_MODAL}.tmpl.html`)
  },
  [CommonModalTemplatesEnum.NUMBER_DELETE_CONFIRMATION]: {
    id: 'number-delete-confirmation',
    html: require(`./../../../views/modals/${CommonModalTemplatesEnum.NUMBER_DELETE_CONFIRMATION}.tmpl.html`)
  },
  [CommonModalTemplatesEnum.AGREEMENTS_UNLIMITED_GB_MODAL]: {
    id: 'agreements-unlimited-gb-modal',
    html: require(`./../../../views/modals/${CommonModalTemplatesEnum.AGREEMENTS_UNLIMITED_GB_MODAL}.tmpl.html`)
  },
  [CommonModalTemplatesEnum.MODAL_LOADER]: {
    id: 'modal-loader',
    html: require(`./../../../views/modals/${CommonModalTemplatesEnum.MODAL_LOADER}.tmpl.html`)
  },
  [CommonModalTemplatesEnum.CREDIT_CHECK_LOADER]: {
    id: 'credit-check-loader',
    html: require(`./../../../views/modals/${CommonModalTemplatesEnum.CREDIT_CHECK_LOADER}.tmpl.html`)
  },
  [CommonModalTemplatesEnum.POS_MODAL]: {
    id: 'pos-modal',
    html: require(`./../../../views/modals/${CommonModalTemplatesEnum.POS_MODAL}.tmpl.html`)
  },
  [CommonModalTemplatesEnum.INFORMATION_ON_LIMITS]: {
    id: 'limit-info-modal',
    html: require(`./../../../views/modals/${CommonModalTemplatesEnum.INFORMATION_ON_LIMITS}.tmpl.html`)
  },
  [CommonModalTemplatesEnum.NIP_BLACKLISTED]: {
    id: 'nip-blacklisted',
    html: require(`./../../../views/modals/${CommonModalTemplatesEnum.NIP_BLACKLISTED}.tmpl.html`)
  },
  [CommonModalTemplatesEnum.SHOW_MORE_ONLINE_AUTHENTICATION]: {
    id: 'show-more-online-authentication',
    html: require(`./../../../views/modals/${CommonModalTemplatesEnum.SHOW_MORE_ONLINE_AUTHENTICATION}.tmpl.html`)
  },
  [CommonModalTemplatesEnum.SHOW_MORE_M_ID_AUTHENTICATION]: {
    id: 'show-more-m-id-authentication',
    html: require(`./../../../views/modals/${CommonModalTemplatesEnum.SHOW_MORE_M_ID_AUTHENTICATION}.tmpl.html`)
  },
  [CommonModalTemplatesEnum.DATA_CHANGE_CONFIRMATION]: {
    id: 'data-change-confirmation',
    html: require(`./../../../views/modals/${CommonModalTemplatesEnum.DATA_CHANGE_CONFIRMATION}.tmpl.html`)
  },
  [CommonModalTemplatesEnum.CONTACT_REQUEST_VIRGIN_MODAL]: {
    id: 'contact-request-virgin-modal',
    html: require(`./../../../views/modals/${CommonModalTemplatesEnum.CONTACT_REQUEST_VIRGIN_MODAL}.tmpl.html`)
  },
  [CommonModalTemplatesEnum.CONTACT_REQUEST_INPUT_VIRGIN_MODAL]: {
    id: 'contact-request-input-virgin-modal',
    html: require(`./../../../views/modals/${CommonModalTemplatesEnum.CONTACT_REQUEST_INPUT_VIRGIN_MODAL}.tmpl.html`)
  },
  [CommonModalTemplatesEnum.VIRGIN_CCDS_CONTACT_SUCCESS]: {
    id: 'virgin-ccds-contact-success',
    html: require(`./../../../views/modals/${CommonModalTemplatesEnum.VIRGIN_CCDS_CONTACT_SUCCESS}.tmpl.html`)
  },
  [CommonModalTemplatesEnum.SHOW_MORE_ID_TYPE_INFORMATION]: {
    id: 'show-more-id-type-information',
    html: require(`./../../../views/modals/${CommonModalTemplatesEnum.SHOW_MORE_ID_TYPE_INFORMATION}.tmpl.html`)
  },
  [CommonModalTemplatesEnum.PROVINCE_SELECT]: {
    id: 'province-select',
    html: require(`./../../../views/modals/${CommonModalTemplatesEnum.PROVINCE_SELECT}.tmpl.html`)
  },
};

@Injectable()
export class CommonModalDataService {
  public modals$ = new BehaviorSubject<CommonModalModel>(null);
  public modalsObs$ = this.modals$.asObservable();
  public initializedModalsList: { [id in CommonModalTemplatesEnum]?: ICommonModalModule } = {};
  public currentModalTemplateName: CommonModalTemplatesEnum = null;
  public tempModalIdInUrl: string = null;
  public modalId: string = '#modal-info';
}
